/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingKey } from '../../models/setting-key';
import { SettingValueResult } from '../../models/setting-value-result';

export interface ApiAdminSettingsKeyGet$Params {
  key: SettingKey;
}

export function apiAdminSettingsKeyGet(http: HttpClient, rootUrl: string, params: ApiAdminSettingsKeyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingValueResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSettingsKeyGet.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingValueResult>;
    })
  );
}

apiAdminSettingsKeyGet.PATH = '/api/Admin/settings/{key}';
